import React from 'react';
import { type EmbeddedReportPayload } from '@aha-app/aha-editor-v2';
import { Panel } from 'components/Dashboards/store/records';
import { getPanelContent } from 'components/Dashboards/helpers';
import ScalingReport from './ScalingReport';
import classNames from 'classnames';

// px padding for top/bottom
const PANEL_PADDING_VERTICAL = 8;
// px padding for right/left
const PANEL_PADDING_HORIZONTAL = 12;

interface EmbeddedReportPanelProps {
  payload: EmbeddedReportPayload;
  width: number;
  height: number;
}

const EmbeddedReportPanel: React.FC<EmbeddedReportPanelProps> = ({
  payload,
  width,
  height,
}) => {
  const panel = new Panel(payload);
  let content: React.ReactNode | null = null;

  if (window.isKnowledgeBase) {
    // Embedded views are not supported when printing (exporting and entire KB
    // to PDF) yet.
    if (window.isPrinting) {
      return null;
    }

    const query = new URLSearchParams([
      ['token', window.knowledgeBaseToken ?? ''],
      ['page_id', window.knowledgeBasePageId ?? ''],
    ]).toString();

    return (
      <div
        className={classNames('tw-flex', 'tw-h-full', {
          'tw-w-full': payload.fullSize,
        })}
      >
        <iframe
          src={`/kb/bookmarks/${payload.bookmarkId}?${query}`}
          style={{
            width,
            border: 'none',
          }}
        />
      </div>
    );
  } else {
    content = getPanelContent(panel, false, width, height, [
      PANEL_PADDING_HORIZONTAL,
      PANEL_PADDING_VERTICAL,
    ]);
  }

  return (
    <ScalingReport
      fullSize={payload.fullSize}
      resizeToFit={payload.resizeToFit && !!window.isPublishing}
      content={content}
    />
  );
};

export default EmbeddedReportPanel;
